<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="localVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-form :rules="rules" ref="form" size="small" :model="formData" label-width="100px">
         <el-form-item label="商户编号" >
          <el-input
            v-model="form.sn"
            clearable
            placeholder="请输入商户编号"
          ></el-input>
         </el-form-item>
        <el-form-item label="商户名称" prop="title">
          <el-input
            v-model="form.merchant_name"
            clearable
            placeholder="请输入商户名称"
            :rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户简称" prop="title">
          <el-input
            v-model="form.shop_name"
            clearable
            placeholder="请输入商户简称"
            :rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="公钥" prop="title">
          <el-input
            v-model="form.public_key"
            clearable
            placeholder="请输入公钥"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="onSubmit('form')">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name:'ePosMember',
    props: {
      visible: {
        type: Boolean,
        default: true,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    },
    data(){
      return {
        localVisible:false,
        form:{
          sn:'',
          merchant_name:'',
          shop_name:'',
          public_key:''
        },
        rules: {
          title: [
            { required: true, message: "请输入标题", trigger: "blur" },
            { min: 2, max: 30, message: "请控制在2-30个字符", trigger: "blur" },
          ]
        },
        curShop:'',
        employee_id:'',
        name_cn:'',

        keywords:'',
        fileList:[],
        mList:[],
        pageNum:1,
        pageSize:10
      }
    },
    mounted() {
      ///this.getList();
    },
    methods:{
      // 关闭
      handleClose() {
        this.$refs["form"].resetFields();
        this.closeForm();
      },
      // 前置提交
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            return false;
          }
        });
      },
      submit() {
          // let param={
          //   appid:this.formData.appid,
          //   private_key:this.formData.private_key,
          //   public_key:this.formData.public_key,
          // }
          // if(this.formData.id){
          //
          // }else{
          //
          // }
      },

      getList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row){
        this.employee_id=row.id;
        this.name_cn=row.name_cn;
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){

      }
    },
    // 监听
    watch: {
      visible(val) {
        if (val) {
          this.localVisible=true;
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
